<script lang="ts">
  import { Button } from "sveltestrap";
  import { AddToWishList, AddtoCart } from "../../../../utils/Constant/Constant";

</script>
<div class="pro-group pb-0">
    <div class="pro-shop">
        <Button color="primary" class="m-r-10" href="/ecommerce/cart"> 
            <i class="fa fa-shopping-basket me-2"></i>{AddtoCart}
        </Button>
        <Button color="danger" href="/ecommerce/checkout"> 
            <i class="fa fa-heart me-2"></i>{AddToWishList}
        </Button>
    </div>
</div>